const ACTIVE_CLASS = "is-active";

const setUpEventReviewsCarousel = () => {
  const carousels = Array.from(document.querySelectorAll("[data-event-reviews-carousel]"));
  if (!carousels.length) {
    return;
  }

  carousels.forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll("[data-event-review-slide]"));
    if (slides.length <= 1) {
      return;
    }

    const prevButton = carousel.querySelector("[data-event-reviews-prev]");
    const nextButton = carousel.querySelector("[data-event-reviews-next]");
    const dots = Array.from(carousel.querySelectorAll("[data-event-reviews-dot]"));
    let activeIndex = slides.findIndex((slide) => slide.classList.contains(ACTIVE_CLASS));
    if (activeIndex < 0) {
      activeIndex = 0;
    }

    const setActiveSlide = (index) => {
      const normalizedIndex = ((index % slides.length) + slides.length) % slides.length;
      activeIndex = normalizedIndex;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === normalizedIndex;
        slide.classList.toggle(ACTIVE_CLASS, isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === normalizedIndex;
        dot.classList.toggle(ACTIVE_CLASS, isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });
    };

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        setActiveSlide(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        setActiveSlide(activeIndex + 1);
      });
    }

    dots.forEach((dot) => {
      const dotIndex = Number.parseInt(dot.getAttribute("data-event-reviews-index") || "", 10);
      if (Number.isNaN(dotIndex)) {
        return;
      }

      dot.addEventListener("click", () => {
        setActiveSlide(dotIndex);
      });
    });

    setActiveSlide(activeIndex);
  });
};

export default setUpEventReviewsCarousel;
